import { supabase } from '../supabase';

interface LeagueSettings {
  salary_cap: boolean;
  max_salary_cap: number;
  number_foward: number;
  number_def: number;
  number_goalie: number;
  number_reserve: number;
  number_scratch?: number;
  salary_cap_reserve: boolean;
  max_salary_cap_reserve: number;
  number_foward_protect: number;
  number_def_protect: number;
  number_goalie_protect: number;
  number_reserve_protect?: number;
  max_demotion: number;
  max_signing: number;
  count_free_agent_signings?: boolean;
  draftMode: boolean;
  draftMinPerPick: number;
  isLineaire: boolean;
  isSerpentin: boolean;
  current_pick: number;
  max_injury: number;
  day_to_comeback: number;
  pts_goal_att: number;
  pts_ass_att: number;
  pts_goal_def: number;
  pts_ass_def: number;
  pts_goal_g: number;
  pts_win_g: number;
  pts_shu_g: number;
  pts_otlosse_g: number;
  protectionlist?: boolean;
  maxdate_protectionlist?: string;
  tradevalidation?: boolean;
  nomouvement?: boolean;
  nmstarth?: number | null;
  nmendh?: number | null;
  nmstartd?: number | null;
  nmendd?: number | null;
  pool_start_date?: string | null;
}

export async function saveLeagueSettings(
  leagueId: number,
  salaryCap: boolean,
  maxSalaryCap: number,
  numberForwards: number,
  numberDefensemen: number,
  numberGoalies: number,
  numberReserves: number,
  salaryCapReserve: boolean,
  maxSalaryCapReserve: number,
  numberForwardsProtect: number,
  numberDefensemenProtect: number,
  numberGoaliesProtect: number,
  maxDemotion: number,
  maxSigning: number,
  draftMode: boolean,
  draftMinPerPick: number,
  isLineaire: boolean = true,
  isSerpentin: boolean = false,
  injuredReserveLimit: number,
  daysToComeback: number,
  ptsGoalAtt: number = 1,
  ptsAssAtt: number = 1,
  ptsGoalDef: number = 2,
  ptsAssDef: number = 1,
  ptsGoalG: number = 5,
  ptsWinG: number = 2,
  ptsShuG: number = 3,
  ptsOtLosseG: number = 1,
  noMovementEnabled: boolean = false,
  noMovementStartHour: number | null = null,
  noMovementEndHour: number | null = null,
  noMovementStartDay: number | null = null,
  noMovementEndDay: number | null = null
) {
  try {
    // First check if a record exists
    const { data: existingData } = await supabase
      .from('league_settings')
      .select('*')
      .eq('league_id', leagueId)
      .single();

    const settings: LeagueSettings = {
      salary_cap: salaryCap,
      max_salary_cap: maxSalaryCap,
      number_foward: numberForwards,
      number_def: numberDefensemen,
      number_goalie: numberGoalies,
      number_reserve: numberReserves,
      salary_cap_reserve: salaryCapReserve,
      max_salary_cap_reserve: maxSalaryCapReserve,
      number_foward_protect: numberForwardsProtect,
      number_def_protect: numberDefensemenProtect,
      number_goalie_protect: numberGoaliesProtect,
      max_demotion: maxDemotion,
      max_signing: maxSigning,
      draftMode: draftMode,
      draftMinPerPick: draftMinPerPick,
      isLineaire: isLineaire,
      isSerpentin: isSerpentin,
      current_pick: 0,
      max_injury: injuredReserveLimit,
      day_to_comeback: daysToComeback,
      pts_goal_att: ptsGoalAtt,
      pts_ass_att: ptsAssAtt,
      pts_goal_def: ptsGoalDef,
      pts_ass_def: ptsAssDef,
      pts_goal_g: ptsGoalG,
      pts_win_g: ptsWinG,
      pts_shu_g: ptsShuG,
      pts_otlosse_g: ptsOtLosseG,
      nomouvement: noMovementEnabled,
      nmstarth: noMovementStartHour,
      nmendh: noMovementEndHour,
      nmstartd: noMovementStartDay,
      nmendd: noMovementEndDay
    };

    if (existingData) {
      // Update existing record
      const { data, error } = await supabase
        .from('league_settings')
        .update(settings)
        .eq('league_id', leagueId);

      if (error) throw error;
      return { data, error: null };
    } else {
      // Insert new record
      const { data, error } = await supabase
        .from('league_settings')
        .insert({
          league_id: leagueId,
          ...settings
        });

      if (error) throw error;
      return { data, error: null };
    }
  } catch (error) {
    console.error('Error saving league settings:', error);
    return { data: null, error };
  }
}

export async function getLeagueSettings(leagueId: number) {
  try {
    const { data, error } = await supabase
      .from('league_settings')
      .select('*')
      .eq('league_id', leagueId)
      .single();

    if (error && error.code !== 'PGRST116') throw error; // PGRST116 is "no rows returned"
    return { data, error: null };
  } catch (error) {
    console.error('Error fetching league settings:', error);
    return { data: null, error };
  }
}